import List from "@/components/list";

const Table = args => {
  /**
   * <el-table-column prop="className" label="班级名称" width="180"></el-table-column>
      <el-table-column prop="trainTypeName" label="培训类型" width="90"></el-table-column>
      <el-table-column prop="trainTime" label="培训时间" width="130"></el-table-column>
      <el-table-column prop="trainDays" label="学制" width="60"></el-table-column>
      <el-table-column prop="organizer" label="主办单位" width="120"></el-table-column>
      <el-table-column prop="trainUnitPosition" label="参训时单位及职务" width="180"></el-table-column>
      <el-table-column prop="isOnlineName" label="办班方式" width="60"></el-table-column>
   */

  const tableConfig = [
    {
      label: "培训名称",
      prop: "className",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "培训类型",
      prop: "trainTypeName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "培训时间",
      prop: "trainTime",
      minWidth: "140",
      showOverflowTooltip: false,
    },
    {
      label: "学制",
      prop: "trainDays",
      minWidth: "40",
      showOverflowTooltip: true
    },
    {
      label: "学时",
      prop: "trainHours",
      minWidth: "40",
      showOverflowTooltip: true
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: " 参训时单位及职务",
      prop: "trainUnitPosition",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "培训方式",
      prop: "isOnlineName",
      minWidth: "80",
      showOverflowTooltip: true
    }
  ];
  return (
    <List
      {...args}
      talbeCols={tableConfig}
    />
  );
};

export default Table;
